<template>
    <div class="row" style="margin-bottom: 0rem">
        <template v-if="!Can(rights.IS_CUSTOMER)">
            <div class="category-widget back"  @click="menuClick({id: -1})">
                <i class="fa fa-caret-left"></i> Back
            </div>
        </template>
        <div v-for="(menuEntry, key) in menu" v-bind:key="key">
            <div v-if="Can(menuEntry.right)" :class="getMenuClass(menuEntry)" @click="menuClick(menuEntry)">
                {{ menuEntry.name }}
            </div>
        </div>
    </div>
</template>

<script>
  import {mapGetters} from 'vuex';
  import {dataTables} from '../../components/mixins/dataTables.js';
  import {swalModals} from '../../components/mixins/swalModals.js';
  import Vue from 'vue';
  import store from '../../store.js';
  import document from '../../components/documents/document.vue';
  import { Can } from '../../../permission/ability.js';
  import uploadDocument from '../../components/documents/uploadDocument.vue'
  import employments from '../../store/employments/employments.js';
  import { RIGHTS } from '../../views/roles/rights';

  export default {
  components: { document, uploadDocument },
    mixins: [dataTables, swalModals],
    data() {
      return {
        id: '',
        rights: RIGHTS
      };
    },
    methods: {
      async created() {
        this.rights = RIGHTS;
      },
      Can,
      getMenuClass(entry) {
        return entry.id === this.entry.id ? ' category-widget active' : ' category-widget'
      },
      menuClick(entry) {
        this.$emit('entryClick', entry);
      },
    },
    props: ['menu', 'entry']
  };
</script>
